<template>
  <el-row class="card-item"
          @click="getActive">
    <div class="label">
      <div class="label">
        {{label}}
        <el-tooltip class="item"
                    effect="dark"
                    :content="tips"
                    placement="right">
          <i class="el-icon-question icon"></i>
        </el-tooltip>

      </div>
      <div class="value">
        {{value}}
      </div>
    </div>
  </el-row>
</template>
<script>
export default {
  props: {
    label: {
      required: true,
    },
    value: {
      required: true
    },
    tips: {
      required: false
    }
  },
  methods: {
    getActive () {
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.card-item {
  font-size: 18px;
  color: #999;
  height: 20%;
  border-right: 4px solid #eee;
  padding-left: 20px;
  & + & {
    margin-top: 10px;
  }
  .icon {
    font-size: 14px;
    cursor: pointer;
  }
  .value {
    font-size: 24px;
    color: #333;
    padding-left: 20px;
    margin-top: 10px;
  }
}

.active {
  border-right-color: #409eff;
}
</style>
